/*
 * Copyright (c) 2024 raqib. All rights reserved.
 * Author: Hamza Essalhi
 * Description: raqib Medical Dashboard - a comprehensive platform tailored for healthcare professionals, facilitating seamless patient management and enhancing practitioner satisfaction. With its intuitive interface and robust features, raqib empowers doctors to efficiently organize patient records, track medical histories, and streamline communication within their practice. By providing a user-friendly experience and customizable tools, raqib simplifies administrative tasks, allowing doctors to focus more on patient care and less on paperwork.
 */


import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useSelector } from 'react-redux';
import GeoErrorPage from '../public/GeoErrorPage';


export default function PublicRouteController() {
  const [isSideNavVisible, setSideNavVisible] = useState(false);
 
  const errorState = useSelector((state) => state?.error) || null;
   const isGeoBlocked = errorState?.errType === "geoBlock";
  


 



  return (
    <>

      {
        !isGeoBlocked ? <Outlet /> : <GeoErrorPage/>
      }

    </>
  );
}